import React, { useState } from 'react';

// Team logos you have
import Team_Hyderabad from './Image/Teams/Hyderabad.webp';
import Team_Shrachi from './Image/Teams/SHRACHI.webp';
import Team_Delhi from './Image/Teams/Delhi SG Pipers.webp';
import Team_Soorma from './Image/Teams/JSW.webp';
import Team_Kalinga from './Image/Teams/Kalinga Lancer.webp';
import Team_TamilNadu from './Image/Teams/Tamilnadu.webp';
import Team_HIL from './Image/Teams/HIL.webp';
import Team_Ranchi from './Image/Teams/RoyalRanchi.webp';

// Map of team keys → name + logo
const TEAMS = {
  HYD: { name: 'Hyderabad Toofans', logo: Team_Hyderabad },
  SRB: { name: 'Shrachi Rarh Bengal Tigers', logo: Team_Shrachi },
  SGP: { name: 'SG Pipers', logo: Team_Delhi },
  JSW: { name: 'JSW Soorma Hockey Club', logo: Team_Soorma },
  VKL: { name: 'Vedanta Kalinga Lancers', logo: Team_Kalinga },
  TND: { name: 'Tamil Nadu Dragons', logo: Team_TamilNadu },
  RAN: { name: 'Royal Ranchi', logo: Team_Ranchi },
  HIL: { name: 'HIL GC', logo: Team_HIL },
  TBD: { name: 'TBD', logo: null },       // knockout placeholders
};

// Small badge when no logo is available
const InitialBadge = ({ name }) => {
  const initials = name
    .split(' ')
    .map(w => w[0])
    .join('')
    .slice(0, 3)
    .toUpperCase();

  return (
    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-slate-200 to-slate-300 text-slate-800 grid place-items-center text-sm font-extrabold">
      {initials}
    </div>
  );
};

const TeamLogo = ({ teamKey }) => {
  const team = TEAMS[teamKey] || TEAMS.TBD;
  if (!team.logo) {
    return <InitialBadge name={team.name} />;
  }
  return (
    <img
      src={team.logo}
      alt={team.name}
      className="w-20 h-auto object-contain"
    />
  );
};

const MatchCard = ({
  matchNo,
  date,
  time,
  stage,
  venue,
  team1Key,
  team2Key,
  score,
  penalty,
}) => {
  const team1 = TEAMS[team1Key] || TEAMS.TBD;
  const team2 = TEAMS[team2Key] || TEAMS.TBD;

  return (
    <div className="text-center py-2 mb-4 w-full shadow-xl rounded-xl">
      <div className="flex items-center justify-center gap-2 pt-2">
        {matchNo && (
          <span className="text-xs px-2 py-0.5 rounded bg-gray-100 font-semibold">
            M#{matchNo}
          </span>
        )}
        <span className="font-bold">{stage}</span>
      </div>

      <span className="font-semibold block mt-1">
        {date} {time && `| ${time}`} | {venue}
      </span>

      <div className="flex justify-evenly items-center gap-5 py-4">
        <TeamLogo teamKey={team1Key} />
        {score ? (
          <div className="grid">
            <span className="text-lg font-bold text-[#3b0067] p-1 rounded-md">
              {score}
            </span>
            {penalty && (
              <span className="text-sm font-semibold text-[#3b0067] p-1 rounded-md">
                {penalty}
              </span>
            )}
          </div>
        ) : (
          <span className="text-lg font-bold text-[#3b0067] p-1 rounded-md">
            Vs
          </span>
        )}
        <TeamLogo teamKey={team2Key} />
      </div>

      <h2 className="bg-[#3b0067] text-white py-2 rounded-md text-sm">
        {team1.name} <span className="font-bold px-1">Vs</span> {team2.name}
      </h2>
    </div>
  );
};

// All fixtures from your 2026 schedule
const MATCHES = [
  // Chennai
  {
    matchNo: 1,
    date: 'Saturday, 3 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'TND',
    team2Key: 'HYD',
  },
  {
    matchNo: 2,
    date: 'Sunday, 4 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'JSW',
    team2Key: 'SRB',
  },
  {
    matchNo: 3,
    date: 'Sunday, 4 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'VKL',
    team2Key: 'RAN',
  },
  {
    matchNo: 4,
    date: 'Monday, 5 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'SGP',
    team2Key: 'HIL',
  },
  {
    matchNo: 5,
    date: 'Tuesday, 6 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'TND',
    team2Key: 'JSW',
  },
  {
    matchNo: 6,
    date: 'Wednesday, 7 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'HIL',
    team2Key: 'SRB',
  },
  {
    matchNo: 7,
    date: 'Wednesday, 7 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'HYD',
    team2Key: 'RAN',
  },
  {
    matchNo: 8,
    date: 'Thursday, 8 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'SRB',
    team2Key: 'VKL',
  },
  {
    matchNo: 9,
    date: 'Friday, 9 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'HYD',
    team2Key: 'JSW',
  },
  {
    matchNo: 10,
    date: 'Friday, 9 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Chennai',
    team1Key: 'TND',
    team2Key: 'SGP',
  },

  // Ranchi
  {
    matchNo: 11,
    date: 'Sunday, 11 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'HIL',
    team2Key: 'VKL',
  },
  {
    matchNo: 12,
    date: 'Sunday, 11 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'RAN',
    team2Key: 'SRB',
  },
  {
    matchNo: 13,
    date: 'Monday, 12 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'SGP',
    team2Key: 'HYD',
  },
  {
    matchNo: 14,
    date: 'Monday, 12 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'HIL',
    team2Key: 'TND',
  },
  {
    matchNo: 15,
    date: 'Tuesday, 13 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'SRB',
    team2Key: 'TND',
  },
  {
    matchNo: 16,
    date: 'Wednesday, 14 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'HYD',
    team2Key: 'VKL',
  },
  {
    matchNo: 17,
    date: 'Wednesday, 14 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'RAN',
    team2Key: 'SGP',
  },
  {
    matchNo: 18,
    date: 'Thursday, 15 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'JSW',
    team2Key: 'HIL',
  },
  {
    matchNo: 19,
    date: 'Friday, 16 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Ranchi',
    team1Key: 'RAN',
    team2Key: 'JSW',
  },

  // Bhubaneswar
  {
    matchNo: 20,
    date: 'Saturday, 17 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'SRB',
    team2Key: 'HYD',
  },
  {
    matchNo: 21,
    date: 'Saturday, 17 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'VKL',
    team2Key: 'SGP',
  },
  {
    matchNo: 22,
    date: 'Sunday, 18 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'SGP',
    team2Key: 'SRB',
  },
  {
    matchNo: 23,
    date: 'Sunday, 18 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'VKL',
    team2Key: 'TND',
  },
  {
    matchNo: 24,
    date: 'Monday, 19 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'HIL',
    team2Key: 'RAN',
  },
  {
    matchNo: 25,
    date: 'Tuesday, 20 January 2026',
    time: '18:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'HYD',
    team2Key: 'HIL',
  },
  {
    matchNo: 26,
    date: 'Tuesday, 20 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'VKL',
    team2Key: 'JSW',
  },
  {
    matchNo: 27,
    date: 'Wednesday, 21 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'TND',
    team2Key: 'RAN',
  },
  {
    matchNo: 28,
    date: 'Thursday, 22 January 2026',
    time: '20:15 hrs',
    stage: 'League',
    venue: 'Bhubaneswar',
    team1Key: 'JSW',
    team2Key: 'SGP',
  },

  // Knockouts
  {
    matchNo: 29,
    date: 'Friday, 23 January 2026',
    time: '18:15 hrs',
    stage: 'Qualifier 1',
    venue: 'Bhubaneswar',
    team1Key: 'TBD',
    team2Key: 'TBD',
  },
  {
    matchNo: 30,
    date: 'Friday, 23 January 2026',
    time: '20:15 hrs',
    stage: 'Eliminator',
    venue: 'Bhubaneswar',
    team1Key: 'TBD',
    team2Key: 'TBD',
  },
  {
    matchNo: 31,
    date: 'Sunday, 25 January 2026',
    time: '18:00 hrs',
    stage: 'Qualifier 2',
    venue: 'Bhubaneswar',
    team1Key: 'TBD',
    team2Key: 'TBD',
  },
  {
    matchNo: 32,
    date: 'Monday, 26 January 2026',
    time: '18:15 hrs',
    stage: '3rd / 4th Place',
    venue: 'Bhubaneswar',
    team1Key: 'TBD',
    team2Key: 'TBD',
  },
  {
    matchNo: 33,
    date: 'Monday, 26 January 2026',
    time: '20:15 hrs',
    stage: 'Final',
    venue: 'Bhubaneswar',
    team1Key: 'TBD',
    team2Key: 'TBD',
  },
];

const Fixture = () => {
  const [visibleMatches, setVisibleMatches] = useState(9);

  const showMoreMatches = () => {
    setVisibleMatches(prev => prev + 9);
  };

  return (
    <div className="max-auto md:px-[6rem]">
      <div className="grid md:grid-cols-3 items-center justify-center gap-6 p-1 pt-10 md:px-10">
        {MATCHES.slice(0, visibleMatches).map(match => (
          <MatchCard key={match.matchNo} {...match} />
        ))}
      </div>

      {visibleMatches < MATCHES.length && (
        <div className="text-center py-4">
          <button
            onClick={showMoreMatches}
            className="px-4 py-2 bg-[#ffbd00] text-black rounded-md font-semibold"
          >
            Show More
          </button>
        </div>
      )}
    </div>
  );
};

export default Fixture;
